import "./manuals.scss";

import React from "react";
import { PageProps, graphql } from "gatsby";
import { useTranslation } from "react-i18next";

import { GetDocDisplayName } from "../utils/GetDocDisplayName";
import manualIcon from "../images/icons/icon-Manuels-Page-Icon-2.svg";
import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { LocalType } from "../models/localType";
import { LocalizedLink } from "../components/primitives";
import SEO from "../components/Seo";
import MainLayout from "../components/layout/MainLayout";

export const query = graphql`
    query ManualsTemplate($code: String!) {
        productsJson(code: { eq: $code }) {
            code
            id
            documents {
                en_CA
                en_US
                fr_CA
                caption {
                    fr_CA
                    en_CA
                    en_US
                }
            }
            title {
                en_CA
                en_US
                fr_CA
            }
        }
    }
`;

export default function Manuals({ data }: PageProps<Queries.ManualsTemplateQuery>) {
    const manual = data.productsJson;
    const { t } = useTranslation("templatePages");
    const currentLocale = usePageLocalization().currentLocale as keyof LocalType;

    return (
        <MainLayout>
            <SEO
                title={`${t("metadata:manuals.title", {
                    SKU: manual?.code,
                })}`}
                description={String(t("metadata:manuals.description", {
                    SKU: manual?.code,
                }))}
            />
            <div className="container">
                <LocalizedLink className="return-to-parts" to="/archives/">
                    <>
                        <span className="iconfont iconfont-return"></span>
                        {t("part-return-message")}
                    </>
                </LocalizedLink>
                <div className="row manuals">
                    <div id="primary">
                        <h1 className="title">{manual?.title?.[currentLocale]}</h1>
                        <h5 className="subtitle">{t("manual")}</h5>
                        <div className="documents">
                            {manual?.documents?.map((document: any) => {
                                if (document?.[currentLocale] === "null") return;

                                return (
                                    <a
                                        key={document?.[currentLocale]}
                                        rel="noreferrer"
                                        target="_blank"
                                        href={"/file/" + document[currentLocale]}
                                        className="document"
                                    >
                                        <img width={30} src={manualIcon} alt={manualIcon} />

                                        <div className="document-info">
                                            <p>
                                                {GetDocDisplayName(document, String(manual?.code))}
                                            </p>
                                            <p className="fileType">(PDF)</p>
                                        </div>
                                        <span className="iconfont iconfont-download download-icon"></span>
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}
